import React, { createContext, useContext } from 'react'
import { useAppData } from '../hooks/useAppData.js'
import { useNavigation } from '../hooks/useNavigation.js'
import { useToast } from '../hooks/useToast.js'

const AppContext = createContext(null)

export function AppProvider({ children }) {
  const dataCtx = useAppData()
  const navCtx = useNavigation()
  const toastCtx = useToast()

  return (
    <AppContext.Provider value={{ ...dataCtx, ...navCtx, ...toastCtx }}>
      {children}
    </AppContext.Provider>
  )
}

export function useApp() {
  const ctx = useContext(AppContext)
  if (!ctx) throw new Error('useApp must be used within AppProvider')
  return ctx
}
